// extracted by mini-css-extract-plugin
module.exports = {"editorHtml":"EditorHtml_editorHtml__1hyJP","compact":"EditorHtml_compact__X6jbu"};